export default __webpack_public_path__ + "static/media/EKRAN_PRZEJSCIE.fa140240.gif";